/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CaseStateView } from '../../models/case-state-view';

export interface CasesCaseIdGet$Params {
  caseId: string;
}

export function casesCaseIdGet(http: HttpClient, rootUrl: string, params: CasesCaseIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CaseStateView>> {
  const rb = new RequestBuilder(rootUrl, casesCaseIdGet.PATH, 'get');
  if (params) {
    rb.path('caseId', params.caseId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CaseStateView>;
    })
  );
}

casesCaseIdGet.PATH = '/cases/{caseId}';
